import { useAuth } from 'react-oidc-context'
import { Navigate } from 'react-router-dom'

export function Login() {
  const auth = useAuth()

  if (auth.isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      background: 'var(--color-bg)',
      backgroundImage: 'radial-gradient(circle, rgba(45,52,80,0.55) 1px, transparent 1px)',
      backgroundSize: '22px 22px',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'var(--font)',
    }}>
      {/* Glow orb behind card */}
      <div style={{
        position: 'fixed',
        top: '30%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 480,
        height: 480,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,229,182,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{
        width: 380,
        animation: 'fadeUp 0.3s ease forwards',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Logo */}
        <div style={{
          textAlign: 'center',
          marginBottom: 40,
        }}>
          <div style={{
            fontFamily: 'var(--font-display)',
            fontSize: 36,
            fontWeight: 800,
            letterSpacing: '-1px',
            color: 'var(--color-text-bright)',
            lineHeight: 1,
            marginBottom: 10,
          }}>
            keel<span style={{
              color: 'var(--color-accent)',
              textShadow: '0 0 20px var(--color-accent-glow)',
            }}>.</span>
          </div>
          <div style={{
            fontFamily: 'var(--font)',
            fontSize: 11,
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: '0.18em',
            color: 'var(--color-text-muted)',
          }}>
            IoT Fleet Control
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)',
          borderTop: '2px solid var(--color-accent)',
          borderRadius: 'var(--radius)',
          padding: '36px 32px',
          boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
        }}>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 18,
            fontWeight: 700,
            color: 'var(--color-text-bright)',
            marginBottom: 6,
            letterSpacing: '-0.2px',
          }}>
            Platform access
          </h1>
          <p style={{
            fontFamily: 'var(--font)',
            fontSize: 13.5,
            color: 'var(--color-text)',
            marginBottom: 28,
            lineHeight: 1.5,
          }}>
            Authenticate via your identity provider to continue
          </p>

          <button
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '11px 16px', fontSize: 14 }}
            onClick={() => auth.signinRedirect()}
          >
            Sign in with Keycloak
          </button>

          {auth.error && (
            <div style={{
              marginTop: 16,
              padding: '10px 12px',
              background: 'var(--color-danger-dim)',
              border: '1px solid rgba(255,69,96,0.25)',
              borderRadius: 'var(--radius-sm)',
              color: 'var(--color-danger)',
              fontSize: 12,
              fontFamily: 'var(--font-mono)',
            }}>
              {auth.error.message}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{
          textAlign: 'center',
          marginTop: 24,
          fontFamily: 'var(--font)',
          fontSize: 11,
          color: 'var(--color-text-dim)',
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
        }}>
          Keel Platform — Enterprise IoT Management
        </div>
      </div>
    </div>
  )
}
